import {
  formatDateOrDash,
  formatDateTimeOrDash,
} from '#/utils/date';
import { formatDisplayAmount } from '#/utils/formatNumber';

function displayOrDash(value) {
  if (value == null || value === '') {
    return '—';
  }
  return value;
}

function formatSupplierLabel(supplier) {
  if (!supplier) {
    return '—';
  }
  const label = [supplier.code, supplier.name].filter(Boolean).join(' - ');
  return label || '—';
}

function formatLookupLabel(lookup) {
  if (!lookup) {
    return '—';
  }
  const label = [lookup.code, lookup.name].filter(Boolean).join(' ');
  return label || '—';
}

/**
 * 採購單 MainInfoCard meta（對齊 UI_DOCUMENT_DETAIL 節奏）。
 * Header 金額只讀 `amountSummary`（禁 fallback `amount`）。
 */
export function mapPurchaseOrderMeta(detail) {
  const amountSummary = detail?.amountSummary;
  const hasAmount = Boolean(amountSummary)
    && (
      amountSummary.subtotalAmount != null
      || amountSummary.taxAmount != null
      || amountSummary.totalAmount != null
    );

  return {
    code: detail?.purchaseOrderNo || '-',
    status: detail?.status || '',
    supplierSubtitle: formatSupplierLabel(detail?.supplier),
    createDate: formatDateTimeOrDash(detail?.record?.createdAt),
    reviseDate: formatDateTimeOrDash(detail?.record?.updatedAt),
    // TERMINATED（中止）沿用結案欄位顯示中止時間
    closeLabel: detail?.status === 'TERMINATED' ? '中止' : '結案',
    closeDate: formatDateTimeOrDash(
      detail?.status === 'TERMINATED' ? detail?.history?.terminatedAt : detail?.history?.closedAt,
    ),
    terminateReason: detail?.history?.terminateReason ?? '',
    purchaseOrderDate: formatDateOrDash(detail?.purchaseOrderDate),
    paymentTerm: formatLookupLabel(detail?.paymentTerm),
    defaultWarehouse: formatLookupLabel(
      detail?.receiptWarehouse ?? detail?.defaultWarehouse,
    ),
    currency: displayOrDash(detail?.currencyCode || detail?.currency?.code),
    exchangeRate: detail?.exchangeRate == null || detail.exchangeRate === ''
      ? '未設定'
      : String(detail.exchangeRate),
    hasAmount,
    subtotalAmount: formatDisplayAmount(amountSummary?.subtotalAmount),
    taxAmount: formatDisplayAmount(amountSummary?.taxAmount),
    totalAmount: formatDisplayAmount(amountSummary?.totalAmount),
    issueReason: detail?.issueReason ?? '',
    remark: detail?.remark ?? '',
  };
}

export { displayOrDash };
